"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useTranslations } from "next-intl";
import { LANGUAGES, LanguageCode, setLocaleCookie } from "@/lib/language";
import { useEditUser, useUserSummary } from "@/lib/api/user";
export function LanguageSwitcher() {
  const $ = _c(19);
  const t = useTranslations();
  const {
    data: summary
  } = useUserSummary();
  const editUser = useEditUser();
  let t0;
  if ($[0] !== editUser || $[1] !== summary?.user) {
    t0 = async function setLanguage(lang) {
      setLocaleCookie(lang);
      if (summary?.user) {
        try {
          await editUser.mutateAsync({
            language: lang
          });
        } catch {}
      }
      window.location.reload();
    };
    $[0] = editUser;
    $[1] = summary?.user;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const setLanguage = t0;
  let t1;
  if ($[3] !== t) {
    t1 = t("language_switcher.current_language_emoji");
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t) {
    t2 = t("language_switcher.label_sr");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <span className="sr-only"> - {t2}</span>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <DropdownMenuTrigger asChild={true}><Button variant="ghost" size="icon">{t1}{t3}</Button></DropdownMenuTrigger>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== setLanguage) {
    t5 = LANGUAGES.map(t6 => {
      const {
        code,
        label,
        flag
      } = t6;
      return <DropdownMenuItem key={code} onClick={() => setLanguage(code)}>{flag} {label}</DropdownMenuItem>;
    });
    $[12] = setLanguage;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <DropdownMenuContent align="end">{t5}</DropdownMenuContent>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t4 || $[17] !== t6) {
    t7 = <DropdownMenu>{t4}{t6}</DropdownMenu>;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}